import { render, staticRenderFns } from "./LicenseTable.vue?vue&type=template&id=759ad53d&"
import script from "./LicenseTable.vue?vue&type=script&lang=ts&"
export * from "./LicenseTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports